module.exports = __webpack_public_path__ + "static/4-ced1838e295e73b0912790b60ed17d53.jpeg";